<template>
  <div id="app">
    <Header v-show="!renderFullScreen"/>
    <main :class="{ 'render-full-screen': renderFullScreen }">
      <transition
        mode="out-in">
        <router-view/>
      </transition>
    </main>
    <Footer v-show="!renderFullScreen"/>
  </div>
</template>

<script>

// libraries
import { mapActions, mapGetters } from 'vuex'

// components
import Header from '@/components/organisms/Header'
import Footer from '@/components/molecules/Footer'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  computed: {
    renderFullScreen: function() {
      return this.$route.name === 'room'
    },
    ...mapGetters({
      httpSuccess: 'httpSuccess',
      httpError: 'httpError'
    })
  },
  methods: {
    ...mapActions({
      validateAuth: 'auth/validate',
    }),
    notifyUncaughtError: function() {
      this.$notify.error({ message: '予期せぬエラーが発生しました。', position: 'top right', timeOut: 5000 })
    }
  },
  async created () {
    await this.validateAuth()
  },
  watch: {
    httpSuccess (success) {
      if (!success) return
      this.$notify.success({ message: success, position: 'top right', timeOut: 5000 })
    },
    httpError (error) {
      if (!error) return
      if (error.response) {
        switch (error.response.status) {
          case 500: {
            this.notifyUncaughtError()
            break
          }
          default: {
            if (error.response.data.errors) {
              for (var message of Array.from(new Set(error.response.data.errors))) {
                this.$notify.error({ message: message.replace(/\s+/g, ''), position: 'top right', timeOut: 5000 })
              }
            } else {
              this.notifyUncaughtError()
            }
          }
        }
      } else {
        this.notifyUncaughtError()
      }
    }
  }
}
</script>

<style lang='scss'>
@import "@/styles/app.scss";
</style>
